<script setup>
// Р11 п.3/4/12: карточка агента/ассистента открывает редактирование по клику
// (без выпадающего меню). В превью показываем подключённые источники;
// удаление живёт внутри формы редактирования.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { dynamicTime } from 'shared/helpers/timeHelper';

import CardLayout from 'dashboard/components-next/CardLayout.vue';

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  updatedAt: {
    type: Number,
    required: true,
  },
  // Подключённые источники [{ id, name }] — показываем для клиентских агентов.
  inboxes: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['action']);
const { t } = useI18n();

const lastUpdatedAt = computed(() => dynamicTime(props.updatedAt));

const inboxNames = computed(() => props.inboxes.map(inbox => inbox.name));

const openEdit = () => emit('action', { action: 'edit', id: props.id });
</script>

<template>
  <CardLayout
    class="cursor-pointer transition-colors hover:bg-n-alpha-1"
    role="button"
    tabindex="0"
    @click="openEdit"
    @keydown.enter="openEdit"
  >
    <div class="flex justify-between w-full gap-1">
      <h6 class="text-base font-normal text-n-slate-12 line-clamp-1">
        {{ name }}
      </h6>
      <span class="text-sm text-n-slate-11 line-clamp-1 shrink-0">
        {{ lastUpdatedAt }}
      </span>
    </div>
    <div class="flex items-center justify-between w-full gap-4">
      <span class="text-sm truncate text-n-slate-11">
        {{ description || t('ASSISTANT.AGENTS.CARD.NO_DESCRIPTION') }}
      </span>
    </div>
    <div v-if="inboxNames.length" class="flex flex-wrap items-center gap-1.5">
      <span class="text-xs text-n-slate-11">
        {{ t('ASSISTANT.AGENTS.CARD.CONNECTED_TO') }}
      </span>
      <span
        v-for="inboxName in inboxNames"
        :key="inboxName"
        class="px-2 py-0.5 text-xs rounded-md bg-n-alpha-2 text-n-slate-12"
      >
        {{ inboxName }}
      </span>
    </div>
  </CardLayout>
</template>
